export enum RegisterModalEnum {
	Cancel = 'cancel',
	Approve = 'approve'
}
